export default __webpack_public_path__ + "static/media/carBaggages.5da6da25.svg";